var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "HiddenEye",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49996 1.5L17.5 16.5M8.81995 7.82248C8.50722 8.13499 8.33144 8.55894 8.33128 9.00106C8.33113 9.44317 8.50661 9.86724 8.81912 10.18C9.13163 10.4927 9.55558 10.6685 9.9977 10.6687C10.4398 10.6688 10.8639 10.4933 11.1766 10.1808M7.80246 3.47083C8.51697 3.26643 9.25679 3.16403 9.99996 3.16667C13.3333 3.16667 16.1108 5.11083 18.3333 9C17.685 10.1342 16.99 11.1033 16.2475 11.9067M14.4641 13.4575C13.105 14.3742 11.6183 14.8333 9.99996 14.8333C6.66663 14.8333 3.88913 12.8892 1.66663 9C2.80746 7.00416 4.09413 5.52083 5.52663 4.54917",
    stroke: "#919CA7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hidden-eye.18e4d2551669ea1e85f85e8116297a82.svg";
export { ForwardRef as ReactComponent };